// Fonts have an arbitrary height limit set in Foundry that is 648
// https://github.com/customink/foundry/blob/ef9afe0db9c313b027b1bfcaee6a3c47a51c1f03/lib/text_generation/postscript_text.rb#L72-L72
export const FOUNDRY_FONT_LIMIT = 648;

// we can not assume a change in font height will result in the width and height
// changing by the same scale. We scale it down to 90% to ensure the text icon
// fits within the canvas, and the font height will not cause problems
// downstream
export const FONT_HEIGHT_BUFFER_SCALE = 0.9;
